import {createI18n} from 'vue-i18n';

//Commons
import commons_en from '@/i18n/commons_en.json';

//HeaderComponent
import headerComponent_en from '@/i18n/components/HeaderComponent_en.json';

//HomeModule
import homeModule_en from '@/modules/home/i18n/i18n_en.json';

//CampaignMopdule
import campaignModule_en from '@/modules/campaigns/i18n/i18n_en.json';

//SendModule
import sendModule_en from '@/modules/sendsms/i18n/i18n_en.json';

//BillingModule
import billingModule_en from '@/modules/billing/i18n/i18n_en.json';

//others
import {logger} from "@/services/logger.service";


export const i18n = createI18n({
    locale: 'en',
    fallbackLocale: 'en',
    silentTranslationWarn: true,
    silentFallbackWarn: true,
    warnHtmlInMessage: false,
    allowComposition: true,
    globalInjection: true,
    messages: {
        en: {
            commons: commons_en,
            header: headerComponent_en,
            home: homeModule_en,
            campaign: campaignModule_en,
            sendmodule: sendModule_en,
            billing: billingModule_en,
        },
    },
});

export function getCurrentLanguage() {
    if (i18n.locale === undefined) {
        if (localStorage.lang != null) {
            i18n.locale = localStorage.lang;
        } else {
            i18n.locale = 'en';
        }
    }
    return i18n.locale;
}

export function setCurrentLanguage(lang) {
    logger.debug("setCurrentLanguage=" + lang)
    localStorage.lang = lang;
    i18n.locale = lang;
}